module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/node_modules/axios/index.js
// module id = 873
// module chunks = 1